<template>
  <b-modal
    :id="`modal-action-${action}`"
    :ref="`modal-action-${action}`"
    :title="`${title} documento`"
    no-close-on-backdrop
    :ok-title="title"
    cancel-title="Cancelar"
    :cancel-disabled="isProcessing"
    @ok="commitAction"
    :ok-disabled="(!!stepOffice.type && !canResendToOffice) || isProcessing"
    @cancel="cancelProcess"
    size="lg"
  >
    <div v-if="action === 'resend'">
      <resend-approval
        :step-id="stepId"
        v-model="resendSubject"
        :is-signer="isSigner"
        :has-signature-positon="hasSignaturePosition"
        :officeType="stepOffice"
        :is-office="isOffice"
        :is-official="isOfficial"
        :officialOfficeId="officialOfficeId"
        @can-resend-to-office="handleCanResendToOffice"
      />
      <div
        v-if="error.message !== ''"
        class="con-text-validation span-text-validation-danger
          vs-input--text-validation-span v-enter-to text-right"
        style="height: 32px;"
      >
        <span class="span-text-validation">
          {{error.message}}
        </span>
      </div>
    </div>
    <div class="mt-2">
      <form data-vv-scope="comment-management">
        <vs-textarea
          class="mb-2"
          maxlength="1000"
          counter="1000"
          label="Comentario"
          v-model="comment"
          name="comment"
          v-validate="{required: action === 'reject', min: 5}"
        />
        <div v-if="errors.first('comment-management.comment')"
             class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to"
             style="height: 20px;">
          <span class="span-text-validation">
            {{errors.first('comment-management.comment')}}
          </span>
        </div>
      </form>
      <div class="my-5 text-right" v-if="enableAttachButton">
        <UploadMultipleFiles
          permission="*"
          text="Agregar"
          v-model="file"
          :upload-to="urlFile"
          type-button="small"
          button-class=""
          container-class="text-right"
          @input="addAdditionalFile()"
        />
      </div>
      <div class="row">
        <div class="col-2" v-for="file in commentFiles" :key="file.id">
          <div class="d-flex flex-column align-items-center">
            <vs-icon icon="description" size="30px" color="primary" />
            <b class="text-truncate w-100 text-center">
              {{ file.name }}
            </b>
            <vs-button
              color="danger"
              type="flat"
              icon="clear"
              @click="removeAdditionalFile(file.id)"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="isProcessing" class="loading-overlay">
      <div class="loading-content">
        <div class="spinner-border spinner-border-lg text-primary" role="status">
          <span class="sr-only">Procesando...</span>
        </div>
        <div class="mt-3">
          <div class="h5 mb-1">Procesando ejecución</div>
          <div class="text-muted">Por favor espera, esto puede tomar unos segundos...</div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
  VBToggle,
  BModal,
  VBModal
} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';

import ResendApproval from '@/febos/chile/approvals/components/trays/managementTray/modals/ResendApproval';
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';
import { rolTypesCode, stepTypesCode } from '@/febos/chile/approvals/components/trays/managementTray/constants';
import UploadMultipleFiles from '@/febos/global/_vue/componentes/UploadMultipleFiles';
import ManageDocument from "@/febos/chile/approvals/components/trays/managementTray/ManageDocument.vue";

export default {
  components: {
    UploadMultipleFiles,
    ManageDocument,
    BModal,
    ResendApproval
  },
  data() {
    return {
      addToFileFolder: false,
      canResendToOffice: true,
      error: {
        message: ''
      },
      comment: '',
      file: [],
      commentFiles: [],
      resendSubject: {
        rolType: rolTypesCode.aprobador,
        type: stepTypesCode.usuario,
        continueFlow: true
      },
      isProcessing: false
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'userSignConfiguration',
      'company',
      'groupsCompany'
    ]),
    ...mapGetters('Approvals', [
      'loading',
      'fileOnFlow',
    ]),
    isAnswerFile() {
      return this.fileOnFlow.detalle.ejecucion.tipoObjetoCategoria === 'respuesta';
    },
    enableAttachButton() {
      return !this.isSiss;
    },
    isSiss() {
      return this.company.iut === '61221000-4';
    },
    urlFile() {
      const { flowId } = this.$route.params;
      return `febos-io/global/${process.env.VUE_APP_AMBIENTE}/empresas/aprobaciones/${flowId}/comentarios`;
    },
    isOffice() {
      return this.stepId.paso.aprobacionesTipoPasoId === stepTypesCode.oficina
        || this.stepId.paso.aprobacionesTipoPasoId === stepTypesCode.oficina.toString() ;
    },
    isOfficial() {
      return this.stepId.paso.aprobacionesTipoPasoId === stepTypesCode.oficial
        || this.stepId.paso.aprobacionesTipoPasoId === stepTypesCode.oficial.toString();
    },
    stepOffice() {
      const office = this.groupsCompany
        .find((group) => group.id === this.stepId.paso.tipoValorResponsableId);

      let officeType;
      if (office) {
        officeType = office.tipo === 'ext' ? StepTypes.EXTERNAL_OFFICES : StepTypes.INTERNAL_OFFICES;
        return { type: !office ? 'int' : office.tipo, codeType: officeType };
      }
      return {};
    },
    officialOfficeId() {
      return this.fileOnFlow?.detalle?.ejecucion?.oficina || '';
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'commentFileFlow',
      'processFileFlow'
    ]),
    handleCanResendToOffice(event) {
      this.canResendToOffice = !!event;
    },
    cancelProcess() {
      this.file = [];
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    makeObjectRequest() {
      const request = {
        idEjecucion: this.$route.params.flowId,
        idAprobacion: this.$route.params.fileId,
        pasoId: this.stepId.id
      };

      const actions = {
        approve: 'aprobar',
        reject: 'rechazar',
        return: 'devolver',
        comment: 'comentario',
        resend: 'reenviar'
      };

      const body = {
        comentario: {
          accion: actions[this.action],
          comentario: this.comment
        },
        documentos: this.commentFiles.map((file) => ({
          tipo: actions[this.action],
          nombre: file.name,
          adjuntoId: file.id,
          adjuntoUrl: file.path,
          adjuntoMime: file.mime,
          adjuntoEstado: 2
        }))
      };

      if (this.action !== 'comment') {
        body.estado = actions[this.action].toUpperCase();
        body.temporalContinuar = this.resendSubject.continueFlow || false;
        if (this.stepOffice.type) {
          body.tipoValorResponsableId = this.resendSubject.id || '';
          body.tipoPaso = stepTypesCode.oficina;
          body.temporalUsuarioId = this.resendSubject.id || '';
        } else {
          body.temporalUsuario = this.resendSubject.name || '';
          body.temporalUsuarioId = this.resendSubject.id || '';
          body.tipoPaso = this.resendSubject.type;
          body.tipoRol = this.resendSubject.tipoRol;
        }
        body.temporalContinuar = this.resendSubject.continueFlow || false;
      }

      return { request, body };
    },
    async sendAction() {
      if (!this.resendSubject.id || this.resendSubject.id === '') {
        this.error.message = 'Oops! Debes seleccionar un usuario/grupo para poder reenviar';
        return;
      }
      if ((!this.resendSubject.rolType || this.resendSubject.rolType === '') &&
        (!this.resendSubject.tipoRol || this.resendSubject.tipoRol === '')) {
        this.error.message = 'Oops! Debes seleccionar un tipo de paso para poder reenviar';
        return;
      }
      this.error.message = '';

      const isValid = await this.validateForm('comment-management');
      if (!isValid) {
        return;
      }
      this.isProcessing = true;

      try {
        if (this.stepOffice.type) {
          if (this.canResendToOffice) {
            const response = await this.processFileFlow(this.makeObjectRequest());

            this.$bvToast.toast(
              `${response.mensaje}`,
              {
                title: '¡Genial!',
                variant: 'primary',
                pauseOnHover: true,
                solid: true,
                noAutoHide: true
              }
            );
          }
        } else {
          const response = await this.processFileFlow(this.makeObjectRequest());
          this.$bvToast.toast(
            `${response.mensaje}`,
            {
              title: '¡Genial!',
              variant: 'primary',
              pauseOnHover: true,
              solid: true,
              noAutoHide: true
            }
          );
        }
        this.$bvModal.hide(`modal-action-${this.action}`);
        this.file = [];
      } finally {
        this.isProcessing = false;
      }
    },
    commitAction(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.sendAction();
    },
    async addAdditionalFile() {
      const newFiles = Array.isArray(this.file) ? this.file : [this.file];
      const validFiles = newFiles.filter((f) => f && !f.failed);

      if (!validFiles.length) {
        return;
      }

      const existingIds = new Set(this.commentFiles.map((f) => f.id));
      const uniqueNewFiles = validFiles.filter((f) => !existingIds.has(f.id));
      this.commentFiles.push(...uniqueNewFiles);

      this.file = validFiles;

      if (validFiles.some((f) => f.failed)) {
        this.error.message = 'Algunos archivos fallaron en la carga';
      }

      await this.$validator.reset();
    },
    removeAdditionalFile(fileId) {
      this.commentFiles = this.commentFiles.filter((file) => file.id !== fileId);
      this.file = this.file.filter((file) => file.id !== fileId);
    }
  },
  props: {
    action: { type: String, required: true },
    title: { type: String, required: true },
    process: { type: Boolean, required: false },
    stepId: { type: Object, required: false },
    getSign: Function,
    numPages: Number,
    isSigner: { type: Boolean, default: false },
    hasSignaturePosition: { type: Boolean, default: false },
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
    'b-modal': VBModal
  },
};
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
}

.loading-content {
  text-align: center;
  padding: 2rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  max-width: 300px;
}

.spinner-border-lg {
  width: 4rem;
  height: 4rem;
  border-width: 0.4em;
}

@media (max-width: 576px) {
  .loading-content {
    margin: 1rem;
    padding: 1.5rem;
  }
}
</style>
